import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=391f371b&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=391f371b&prod&lang=css"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=391f371b&prod&lang=css"
import style2 from "./sidebar.vue?vue&type=style&index=2&id=391f371b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f371b",
  null
  
)

export default component.exports